import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from '../src/reducers'
import createSagaMiddleware from 'redux-saga'
import rootSaga from '../src/sagas'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

/*const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, 
    compose(
        applyMiddleware(
            sagaMiddleware
        ),
    ),
)

sagaMiddleware.run(rootSaga)*/

ReactDOM.render((
    <App  />
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
